/**
 * @file src/pages/refunds/components/StatCard.jsx
 * @description Single statistic card used in the Refunds page header row.
 *
 * Pure presentational. Pass label, value (string or number), an icon name
 * (from the AppIcon set), and a Tailwind color string for the icon badge.
 *
 * Example:
 *   <StatCard
 *     label="Total Refunds"
 *     value={42}
 *     icon="RotateCcw"
 *     color="text-red-500 bg-red-100 dark:bg-red-900/20 dark:text-red-400"
 *   />
 */

import React from "react";
import Icon from "components/AppIcon";

const StatCard = ({ label, value, icon, color }) => (
  <div className="bg-card rounded-xl p-4 shadow-sm border border-border flex items-center gap-3">
    <div
      className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${color}`}
    >
      <Icon name={icon} size={20} />
    </div>
    <div className="min-w-0">
      <p className="text-xl font-bold text-foreground truncate">{value}</p>
      <p className="text-xs text-muted-foreground">{label}</p>
    </div>
  </div>
);

export default StatCard;
